import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

dayjs.extend(isSameOrAfter);

/** STAR "Start New Recommendation" CommunityForce URL switches on this date. */
export const STAR_2026_RECOMMENDATION_URL_EFFECTIVE_DATE = '2026-08-15';

/** PSA "Start New Nomination" CommunityForce URL switches on this date. */
export const PSA_2026_NOMINATION_URL_EFFECTIVE_DATE = '2026-08-20';

export function isStar2026RecommendationUrlEffective(): boolean {
  return dayjs().isSameOrAfter(
    STAR_2026_RECOMMENDATION_URL_EFFECTIVE_DATE,
    'day'
  );
}

export function isPsa2026NominationUrlEffective(): boolean {
  return dayjs().isSameOrAfter(PSA_2026_NOMINATION_URL_EFFECTIVE_DATE, 'day');
}
